import styled from "styled-components";
import { Sidebar } from "react-pro-sidebar";

export const StyledSidebar = styled(Sidebar)`
  height: 100vh;
  overflow-y: hidden;

  .ps-collapsed {
    width: 0 !important;
    min-width: 0 !important;
  }

  .ps-menu-button:hover {
    background-color: var(--surface-border) !important;
  }

  .ps-menu-label {
    font-size: 0.85rem !important;
    font-weight: 500;
  }

  .active-menu-item {
    background-color: var(--surface-border);
  }

  .default-menu-item {
    background-color: transparent;
  }

  .custom-tree-menu-item {
    overflow: visible !important;

    &:hover {
      background-color: transparent !important;
    }

    .ps-menu-button {
      overflow: visible !important;
      height: auto !important;
      padding: 8px 0 !important;

      &:hover {
        background-color: transparent !important;
      }
    }

    .ps-menu-label {
      overflow: visible !important;
      white-space: normal !important;
      flex: 1;
      display: block;
      width: 100% !important;
    }
  }

  .custom-tree-menu-item .ps-menu-button {
    overflow: visible !important;
    height: auto !important;
    padding: 8px 0 !important;
  }

  .custom-tree-menu-item .ps-menu-label {
    overflow: visible !important;
    white-space: normal !important;
    flex: 1;
    display: block;
    width: 100% !important;
  }

  .css-dip3t8 {
    background-color: ${({ theme }) => theme.colors.menuBackground} !important;
    overflow-y: hidden;
  }
`;

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const TreeMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
`;

export const TreeViewContainer = styled.div<{ $isClosed: boolean }>`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0 8px;
  max-height: 92vh;
  overflow-y: scroll;
  opacity: ${({ $isClosed }) => ($isClosed ? 0 : 100)};
  transition: opacity 0.5s ease;

  /* Firefox */
  scrollbar-width: none;
  /* IE/Edge */
  -ms-overflow-style: none;

  /* Chrome, Safari, Edge (новый) */
  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 1500px) {
    max-height: 90vh;
  }
  @media screen and (max-width: 1440px) {
    max-height: 87vh;
  }
  @media screen and (max-width: 1200px) {
    max-height: 85vh;
  }
  @media screen and (min-width: 2100px) {
    max-height: 94vh;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 10px 0 10px 10px;
  align-items: center;

  &:hover {
    i {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;

export const CloseButton = styled.div`
  padding: 10px;
  color: ${({ theme }) => theme.colors.menuIcon};
`;
